<template>
  <div
    id="createFolderELearningModal"
    class="modal fade"
    tabindex="-1"
    role="dialog"
    aria-labelledby="modelSingle"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-lg" role="document">
      <!--begin::Form-->
      <form class="kt-form" @submit="formSubmit">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{ this.$route.meta.breadcrumb }}</h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div class="modal-body">
            <div class="kt-portlet__body">
              <div class="kt-section kt-section--first">
                <div class="row">
                  <div class="col-xl-12">
                    <div class="form-group">
                      <label class="label-required">ชื่อหมวดหมู่</label>
                      <input
                        type="text"
                        class="form-control"
                        id="cfelSubFolderName"
                        name="cfelSubFolderName"
                        v-model="cfelSubFolderName"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
            >
              <i class="la la-close"></i> ปิดหน้าต่าง
            </button>
            <button type="submit" class="btn btn-primary">
              <i class="la la-save"></i> บันทึก
            </button>
          </div>
        </div>
      </form>
      <!--end::Form-->
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  components: {
  },
  data: function() {
    var self = this;
    return {
      cfelSubFolderName : null

      };
  },
  methods: {
    formSubmit: function(e) {
      e.preventDefault();
      let self = this;
      let router = this.$router;

      if (
        !$("#createFolderELearningModal form")
          .validate()
          .form()
      ) {
        return false;
      }

      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังบันทึกข้อมูล กรุณารอสักครู่...",
      });

      
      axios({
        method: "post",
        url: "/Api/Folder/AddSubFolder",
        data: {
          folderName : self.cfelSubFolderName,
          parentFolderId : router.currentRoute.params.id
        }
      })
        .then(function(response) {
          if (response.data.status) {
            Swal.fire("สำเร็จ", response.data.message, "success").then(
              function() {
                $("#createFolderELearningModal").modal("hide");
                //this.$router.push(`/5S/E-Learning/Detials/${router.currentRoute.params.id}`);
                //this.$router.go();
              }
            );
          } else {
            Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
          }
        })
        .catch(function(error) {
          Swal.fire(
            "เกิดข้อผิดพลาด",
            error.response.data.message,
            "error"
          ).then(function() {
            $("#createFolderELearningModal").modal("hide");
          });
        })
        .then(function() {
          // always executed
          KTApp.unblockPage();
        });
    },
  },
  async mounted() {
    let self = this;
    let router = this.$router;
    let user = await this.$root.getUser();

    // set validation rules
    $("#createFolderELearningModal form").validate({
      rules: {
        cfelSubFolderName: "required"
      },
      messages: {
        cfelSubFolderName: "กรุณาระบุหมวดหมู่"
      },
    });

    $("#createFolderELearningModal")
      .on("hidden.bs.modal", function() {
        // Set go back
        router.go(-1);
        self.$parent.reloadDataTable(false);
      })
      .modal("show");
  },
};
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// App/Components/5S/CreateSubFolderELearningModal.vue